import { react, useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from '../../services/TokenService';
import Box from '@mui/material/Box';
import styles from '../CustomerPortal/CustomerLogin.module.css'; // Import css modules stylesheet as styles
import '../CustomerPortal/PasswordStrength.css';
import PasswordInput from "react-password-indicator";
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { useSnackbar } from 'notistack';

export default function CharityVerification() {
    const [isLoading, setIsLoading] = useState(false);
    const [organization, setOrganization] = useState(null);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    useEffect(() => {
        // first load processing
        let queryParams = new URLSearchParams(window.location.search);
        let token = queryParams.get("token");

        if (token != null) {
            if (token.length > 15) {

                loadVerificationStatus(token);
            }
        }
    }, [])

    function loadVerificationStatus(token) {
        let postData = { tag: token };
        TokenService.customerPost(postData, 'DonationGetStatus', '')
            .then((response) => {
                setIsLoading(false);
                if (response.Result === undefined) {
                    let keys = Object.keys(response);
                    response = response[keys[0]];
                }
                if (response.Result === 'SUCCESS') {
                    setOrganization(JSON.parse(response.JsonData));
                }

            })
            .catch((response) => {
                //error occurred? Don't stop the customer's order
                setIsLoading(false);
                enqueueSnackbar(response.Message, {
                    variant: 'error',
                });

            });
    }

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )
    }

    function validatePasswordRegistration() {
        let errors = {};
        let isValid = true;

        if (password.trim() == '') {
            isValid = false;
            errors['password'] = 'Required';
        }
        else {
            if (password2.trim() !== password.trim()) {
                errors['password2'] = 'Passwords do not match.'
                isValid = false;
            }
        }

        setFormErrors(errors);

        if (isValid) {
            let postData = {
                organization: organization,
                value: password.trim()
            }

            
            TokenService.customerPost(postData, 'DonationCompleteVerification', '')
                .then((response) => {
                    setIsLoading(false);
                    if (response.Result === undefined) {
                        let keys = Object.keys(response);
                        response = response[keys[0]];
                    }
                    if (response.Result === 'SUCCESS') {
                        setOrganization(JSON.parse(response.JsonData));
                    }

                })
                .catch((response) => {
                    //error occurred? Don't stop the customer's order
                    setIsLoading(false);
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });

                });
        }
    }


    return (<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        {isLoading ? buildLoadingPanel()
            :
            <div>
                {organization == null ?
                    null
                 :
                <div>
                        {organization.Status == 'Pending Verification' ?
                            <>
                                <div className={styles.cardHeader}>Email Verified</div>
                                <div style={{marginTop:'10px',marginBottom:'10px'} }>Let's create a password for your account.</div>
                                <div className={styles.ContactSectionBody}>
                                   
                                    <PasswordInput
                                        minLen={5}
                                        digits={1}
                                        uppercaseChars={1}
                                        lowercaseChars={1}
                                        maxLen={24}
                                        onChange={(value) => setPassword(value)}
                                       
                                    >
                                        {({ getInputProps, getProgressProps, valid, hasRulePassed, rules, errors, touched }) => (
                                            <>
                                                
                                                <TextField label="Password" variant="outlined" type="password" {...getInputProps()} className={touched ? (valid ? 'success' : 'error') : ''} />
                                                
                                                {touched && (
                                                    <div>
                                                        <progress {...getProgressProps()} />
                                                        <p>Password is {!valid && 'in'}valid!</p>
                                                    </div>
                                                )}
                                                <p>
                                                   
                                                    <ul>
                                                        {rules.map((r) => (
                                                            <li
                                                                key={r.key}
                                                                className={touched ? (hasRulePassed(r.key) ? 'success' : 'error') : ''}
                                                            >
                                                                {r.message}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </p>
                                            </>
                                        )}
                                    </PasswordInput>
                                </div>

                                <div className={styles.ContactSectionBody}>
                                    <TextField className={styles.ContactSectionText} error={formErrors['password2'] !== undefined} label="Re-enter Password" onChange={(e) => setPassword2(e.target.value)} value={password2} variant="outlined" type="password"

                                    />
                                    <div className={styles.FormFieldErrorDescription} style={{ textAlign: 'left' }}> {formErrors['password2'] !== undefined ? formErrors['password2'] : ''}</div>
                                </div>

                                <div className={styles.ContactSectionBody}>
                                    <Button variant='outlined' style={{ marginTop: '15px', alignSelf: 'center' }} onClick={() => validatePasswordRegistration()}>Submit</Button>
                                </div>
                            </>
                            : organization.Status == 'Pending Review' ?
                                <div style={{marginTop:'25px'} }>
                                    <div>We have received your application and will review it as soon as possible.</div>
                                    <div>We will contact you using the email you provided.</div>

                                </div>
                                : organization.Status == 'Active' ?
                                    <>
                                        Your account is active. Please log using the Customer Portal.
                                    </>
                                    :
                                    <>
                                        Please contact us at info@sipzee.com
                                    </>
                        }
                </div>
                }
            </div>
        }
       
    </div>);

}